import { Loading, Typography } from "@cpj-ai/panel-npm-package";
import { AuthAccountJobPositionAssignmentStatusChoices, useGetJobPositionAssignmentsQuery } from "@graphql/generated";
import JobCard from "@modules/JobSuggestion/components/JobCard";

const AcceptedPositionsTabContent = () => {
  const status = AuthAccountJobPositionAssignmentStatusChoices.NOT_REVIEWED;
  const { data, loading } = useGetJobPositionAssignmentsQuery({
    variables: {
      jobSeekerStatus: [
        status,
        AuthAccountJobPositionAssignmentStatusChoices.AWAITING_INTERVIEW_DATE,
        AuthAccountJobPositionAssignmentStatusChoices.INTERVIEW_SCHEDULED,
        AuthAccountJobPositionAssignmentStatusChoices.INTERVIEW_DONE,
      ],
    },
  });

  const jobPositions = data?.me?.jobPositionAssignments?.edges;

  if (loading) return <Loading />;

  return (
    <div className="flex flex-col gap-4 h-4/6 overflow-auto">
      {jobPositions?.length && jobPositions?.length > 0 ? (
        jobPositions?.map((job, index) => <JobCard key={index} jobPosition={job?.node} status={status} />)
      ) : (
        <Typography variant="muted" className="text-center py-32">
          There is no job suggestion
        </Typography>
      )}
    </div>
  );
};

export default AcceptedPositionsTabContent;
